import { connect } from "react-redux";
import { Action, Dispatch } from "redux";

import { healthCheckAction } from "../../../actions";
import { RootState } from "../../../reducers";
import SystemHealth from "./SystemHealth";

interface OwnProps {
  isOpen: boolean;
  canCancel?: boolean;
  onClose: () => void;
}

const mapStateToProps = (state: RootState, props: OwnProps) => ({
  ...props,
  loading: Boolean(state.ajax.submitting),
  health: state.healthCheck.health,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  healthCheck: () => {
    dispatch(healthCheckAction.request());
  },
});

/**
 * Wrapped component
 */
const wrappedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SystemHealth);

export default wrappedComponent;
